<div class="inner-page-header">
  <h3>
    ادارة المجتمعات / <a [routerLink]="'/pages/community/community-details/' + communityId">{{ communityName }}</a>
    <span class="community-symbole">{{ communityCode }}</span>
    <span class="status">نشط</span>
  </h3>
</div>
<div class="community-wrapper">
  <h4 class="font-bold font-16">روابط المشاركة</h4>
  <div class="links-wrapper">
    <app-link-card class="link-item" 
      [label]="'رابط الدعوة'" 
      [link]="invitationWebpageLink" 
      [mode]="'قبل الندوة · mode=invite'">
    </app-link-card>

    <app-link-card class="link-item" 
      [label]="'رابط الاستبيان'"
      [link]="surveyWebpageLink" 
      [mode]="'بعد الندوة · mode=offer'">
    </app-link-card>

    <app-link-card class="link-item" 
      [label]="'رابط الخدمات'"
      [link]="servicesWebpageLink" 
      [mode]="''">
    </app-link-card>
  </div>
</div>
